/**
 * created by xcc
 状态和颜色对应关系
 *
 */

// 流程状态颜色
const statusColors = {
    "submit": "#02A7F0",
    "finishColor": "#008000",
    "back": "#78D21D",
    "processColor": "#999999",
    "noPass": "#FF1313",
    "delColor": "#CCC",
};

// 流程类型颜色
const activityTypeColors = {
    "add": "#61A0FF",
    "update": "#89D069",
    "signOut": "#CCCCCC",
    "delete": "#F56C6C",
    "annual": "#EFAD2A",
    "assign": "#000000",
};

const colorByStatus = {
    "提交": statusColors["submit"],
    "返回": statusColors["back"],
    "草稿": statusColors["processColor"],
    "通过":statusColors["finishColor"],
    "不通过": statusColors["noPass"],
    "删除":statusColors["noPass"],
    "已注销":statusColors["noPass"],
};

const colorByActivityType = {
    0: activityTypeColors["add"],
    1: activityTypeColors["update"],
    2: activityTypeColors["signOut"],
    3:activityTypeColors["delete"],
    4: activityTypeColors["annual"],
    5: activityTypeColors["assign"],
};

export const getColorByStatus = (state) => {
    let color = statusColors["processColor"];
    if(!state || typeof state !== "string") return color;
    for (var key in colorByStatus) {
        if (state.indexOf(key) > -1) {
            color = colorByStatus[key]
        }
    }
    return color;
};

export const getColorByActivityType = (state) => {
    return colorByActivityType[state] || activityTypeColors["add"];
};
